'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styled = require('./styled');

var _styled2 = _interopRequireDefault(_styled);

var _PdfPreview = require('../PdfPreview');

var _PdfPreview2 = _interopRequireDefault(_PdfPreview);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PdfPreviewPopup = function PdfPreviewPopup(_ref) {
  var closePopup = _ref.closePopup,
      link = _ref.link,
      spPlatformConfig = _ref.spPlatformConfig;
  return _react2.default.createElement(_styled2.default.Popup, null, _react2.default.createElement(_styled2.default.PopupInner, null, _react2.default.createElement(_PdfPreview2.default, {
    spPlatformConfig: spPlatformConfig,
    closePopup: closePopup,
    width: 530,
    link: link
  })), _react2.default.createElement(_styled2.default.Icon, {
    onClick: closePopup
  }));
};

exports.default = PdfPreviewPopup;